


















import {Component, Prop, Vue} from "vue-property-decorator";
import {IBlackListRule, IWhiteListRule} from "@/modules/Segmentation/models/SegmentationRules";
import StringArrayForm from "@/components/StringArrayForm.vue";

const isWhiteList = (obj: IWhiteListRule | IBlackListRule): obj is IWhiteListRule => {
    return obj.hasOwnProperty("whiteList");
};

@Component({
    components: {StringArrayForm}
})
export default class StringArrayFormInvertible extends Vue {
    @Prop() public readonly label!: string;
    @Prop() public readonly blackListHint?: string;
    @Prop() public readonly whiteListHint?: string;
    @Prop() public readonly blackListSwitchLabel?: string;
    @Prop() public readonly whiteListSwitchLabel?: string;
    @Prop() public readonly value!: IWhiteListRule | IBlackListRule;
    @Prop() public readonly rules?: [];

    get switchLabel(): string {
        let res: string;

        if (isWhiteList(this.value)) {
            if (this.value.isException) {
                res = this.blackListSwitchLabel || "";
            } else {
                res = this.whiteListSwitchLabel || "";
            }
        } else {
            if (this.value.isException) {
                res = this.whiteListSwitchLabel || "";
            } else {
                res = this.blackListSwitchLabel || "";
            }
        }

        return res;
    }

    get hint(): string {
        let res: string;

        if (isWhiteList(this.value)) {
            if (this.value.isException) {
                res = this.blackListHint || "";
            } else {
                res = this.whiteListHint || "";
            }
        } else {
            if (this.value.isException) {
                res = this.whiteListHint || "";
            } else {
                res = this.blackListHint || "";
            }
        }

        return res;
    }

    get model(): string[] {
        let res: string[];

        if (isWhiteList(this.value)) {
            res = this.value.whiteList || [];
        } else {
            res = this.value.blackList || [];
        }

        return res;
    }
}
